var loc = window.location.hash
if (window.location.hash == "#/" || window.location.hash == ""){
  window.location.hash = "!/";
}
window.dataLayer = []